import { ar as common } from "./common.js";
import { ar as auth } from "./auth.js";
import { ar as emails } from "./emails.js";
import { ar as shared } from "./shared.js";
import { ar as errors } from "./errors.js";
import { ar as nav } from "./nav.js";
import { ar as notifications } from "./notifications.js";
import { ar as preferences } from "./preferences.js";
import { ar as profile } from "./profile.js";
import { ar as activities } from "./activities.js";
import { ar as customers } from "./customers.js";
import { ar as settings } from "./settings.js";
import { ar as reports } from "./reports.js";
import { ar as billing } from "./billing.js";
import { ar as triggers } from "./triggers.js";
import { ar as labels } from "./labels.js";

export const ar = {
  common,
  auth,
  emails,
  shared,
  errors,
  nav,
  notifications,
  preferences,
  profile,
  activities,
  customers,
  settings,
  reports,
  billing,
  triggers,
  labels,
};
